export default __webpack_public_path__ + "static/media/mobi-trustedDev-inactiveTab.bc5a32e8.svg";